module.exports = "/_next/static/images/564977641eb791c25d13d79a51ff5a4e-hero-lg.jpg.webp";